import { IServiceOptions } from "./types";

export const serviceOptions: IServiceOptions[] = [
  {
    id: 1,
    value: "BAGGAGE",
    title: "Завантаження салону",
  },
  {
    id: 2,
    value: "ANIMAL",
    title: "Перевезення тварин",
  },
  {
    id: 3,
    value: "CONDIT",
    title: "Кондиціонер",
  },
  {
    id: 4,
    value: "MEET",
    title: "Зустріч із табличкою",
  },
  {
    id: 5,
    value: "COURIER",
    title: "Кур'єрська доставка",
  },
  {
    id: 6,
    value: "CHECK",
    title: "Чек",
  },
  {
    id: 7,
    value: "BABY_SEAT",
    title: "Дитяче крісло",
  },
  {
    id: 8,
    value: "DRIVER",
    title: "Водій",
  },
  {
    id: 9,
    value: "NO_SMOKE",
    title: "Водій, який не палить",
  },
  {
    id: 10,
    value: "ENGLISH",
    title: "",
  },
  {
    id: 11,
    value: "ENGLISH",
    title: "Англомовний водій",
  },
  {
    id: 12,
    value: "CABLE",
    title: "Трос",
  },
  {
    id: 13,
    value: "FUEL",
    title: "Підвезення бензину",
  },
  {
    id: 14,
    value: "WIRES",
    title: "Дроти",
  },
  {
    id: 15,
    value: "SMOKE",
    title: "Я буду курити",
  },
];

export const getRenderableOptions = (options: string[]) => {
  return options
    .map((option) => serviceOptions.find((service) => service.value === option))
    .filter(
      (
        matchedOption,
      ): matchedOption is { id: number; value: string; title: string } =>
        !!matchedOption?.title,
    )
    .map((matchedOption) => ({
      id: matchedOption.id,
      value: matchedOption.value,
      title: matchedOption.title.toUpperCase(),
    }));
};

export const capitalizeFirstLetter = (str: string) => {
  if (!str) return "";
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
};
